import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const login = async (email, password) => {
  const response = await apiClient.post('/auth/login', new URLSearchParams({
    username: email,
    password: password,
  }), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    }
  });
  console.log('headers', response.headers);
  console.log('data', response.data);

  if (response.data.access_token) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }
  return response.data;
};

const logout = () => {
  localStorage.removeItem('user');
};

const refreshToken = async () => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.refresh_token) {
    try {
      const response = await apiClient.post('/auth/refresh', {
        refresh_token: user.refresh_token,
      });
      user.access_token = response.data.access_token;
      localStorage.setItem('user', JSON.stringify(user));
      return user.access_token;
    } catch (error) {
      logout();
      return Promise.reject('Failed to refresh token');
    }
  }
  return Promise.reject('No refresh token found');
};

const authService = {
  login,
  logout,
  refreshToken,
};

export default authService;